/**
 * nav
 */

import Page from '~/page/page';
import $ from 'jquery';

export default class Drop extends Page {
  init() {
    this.elements({
      link: '.js-drop-link',
      close: '.js-drop-close',
      image: '.js-drop-image'
    });
  }
  events() {
    this.$.link.on('mouseenter', e => this.handler(e));
    this.$.close.on('click', e => {
      this.$.root.trigger('drop.close');
    });
  }
  handler(e) {
    const $target = $(e.target);
    const image = this.getImage($target);

    if (this.isCurrent($target)) return;

    if (null !== image) {
      this.setCurrent($target);
      this.updateImage(image);
    }
  }
  isCurrent($target) {
    return $target.is('.is-current');
  }
  setCurrent($target) {
    this.$.link.removeClass('is-current');
    $target.addClass('is-current');
  }
  getImage($target) {
    return $target.data('image') || null;
  }
  updateImage(image) {
    this.$.image.stop(true).fadeOut(300, () => {
      this.$.image.css({ 'background-image': `url(${image})` });
      this.$.image.fadeIn(300);
    });
  }
}

Page.mount(Drop, '.js-drop');
